import { useMemo } from 'react';
import {
  getTaskEstimatedDurationRange,
  isNestedEstimatedDurationRollup,
} from '../../../../FlowchartView/utils/progressUtils';

/**
 * Resolves display est. time for a task, including nested-campaign rollup.
 */
export function useTaskEstimatedDuration(
  task,
  { statuses = [], nestedSprints = [], allSprints = [] } = {},
) {
  return useMemo(() => {
    const { minMinutes, maxMinutes } = getTaskEstimatedDurationRange(task, {
      statuses,
      nestedSprints,
      allSprints,
    });
    const isNestedRollup = isNestedEstimatedDurationRollup(task);
    return { minutes: maxMinutes, minMinutes, maxMinutes, isNestedRollup };
  }, [task, statuses, nestedSprints, allSprints]);
}
